import httpClient from '%app/js/httpClient';
import { createRequest } from '@paysera/http-client-common';
import { router } from '%app/js/common/services/router';

class HallClient {
    getHall(token) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection_integration.hall.get_by_event', { token }),
        );
        return httpClient.performBaseRequest(request);
    }

    getHallSvg(uri) {
        return fetch(`/${uri}`).then(blob => blob.text());
    }

    getTicketTypesByEvent(token) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection_integration.ticket_types.get_by_event', { token }),
        );
        return httpClient.performBaseRequest(request);
    }

    getSectorsByEvent(token) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection_integration.sectors.get_by_event', { token }),
        );
        return httpClient.performBaseRequest(request);
    }

    getSectorDetailsByEvent(token, sectorHash) {
        const request = createRequest(
            'GET',
            router.generate('paysera_seat_selection_integration.sector_details.get_by_event', { token, sectorHash }),
        );
        return httpClient.performBaseRequest(request);
    }
}

export default new HallClient();
